import React from "react";
import { Card, Typography, List, Tag, Row, Col, Button } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const { Title, Text, Paragraph } = Typography;

const ExamReview = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { courseId } = useParams();
    const { examResult } = location.state || {};

    if (!examResult) {
        return (
            <Card>
                <Title level={3}>No exam result to review</Title>
                <Button type="primary" onClick={() => navigate(`/course/${courseId}`)}>
                    Return to Course
                </Button>
            </Card>
        );
    }

    return (
        // <Card title="ทบทวนการสอบ">
        <Card title="เฉลยคำตอบ">
            {/* <Row justify="center" style={{ marginBottom: 24 }}>
                <Col>
                    <Title level={2} align="center">
                        {examResult.passed ? "สอบผ่าน!" : "สอบไม่ผ่าน"}
                    </Title>
                    <Paragraph style={{ textAlign: "center" }}>
                        คะแนนของคุณ {examResult.totalPoints} จากทั้งหมด {examResult.totalPossiblePoints} คะแนน (
                        {Math.round(examResult.percentageScore)}%)
                    </Paragraph>
                </Col>
            </Row> */}

            <List
                // header={<Title level={4}>ทบทวนคำถาม</Title>}
                itemLayout="vertical"
                dataSource={examResult.questionResults}
                renderItem={(item, index) => (
                    <List.Item
                        key={item.questionId}
                        extra={
                            <Tag color={item.isCorrect ? "green" : "red"}>
                                {item.isCorrect ? (
                                    <span>
                                        <CheckCircleOutlined /> ถูก
                                    </span>
                                ) : (
                                    <span>
                                        <CloseCircleOutlined /> ผิด
                                    </span>
                                )}
                            </Tag>
                        }
                    >
                        <List.Item.Meta
                            title={
                                <div>
                                    <Text strong>คำถามที่ {index + 1}:</Text> {item.questionText}
                                </div>
                            }
                            description={
                                <>
                                    <div>
                                        <Text type={item.isCorrect ? "success" : "danger"}>
                                            คำตอบของคุณ: {item.userAnswer}
                                        </Text>
                                    </div>
                                    {!item.isCorrect && (
                                        <div>
                                            <Text type="success">คำตอบที่ถูกต้อง: {item.correctAnswer}</Text>
                                        </div>
                                    )}
                                    <div style={{ marginTop: 8 }}>
                                        <Text>
                                            {/* คำแนน: {item.points}/{item.maxPoints} */}
                                            <Text>คำอธิบายคำตอบ:</Text> {item.explainAnswer}
                                        </Text>
                                    </div>
                                </>
                            }
                        />
                    </List.Item>
                )}
            />

            <div style={{ marginTop: 24, textAlign: "center" }}>
                <Button type="primary" onClick={() => navigate(`/course/${courseId}`)}>
                    กลับไปยังบทเรียน
                </Button>
            </div>
        </Card>
    );
};

export default ExamReview;
